import React, { createContext, useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";
import UserProvider from "./userContext";
import MapProvider from "./mapContext";
import MachineProvider from "./machineContext";
import GiftBasketProvider from "./giftBasketContent";

export const RootContext = createContext();
export const useRootContext = () => useContext(RootContext);
const RootProvider = ({ children }) => {
  return (
    <RootContext.Provider value={{}}>
      <UserProvider>
        <GiftBasketProvider>
          <MapProvider>
            <MachineProvider>{children}</MachineProvider>
          </MapProvider>
        </GiftBasketProvider>
      </UserProvider>

      <Outlet />
    </RootContext.Provider>
  );
};

export default RootProvider;
